import { httpClient } from "@/lib/http-client/http-client";
import { API_ROUTES } from "@/shared/constants/api.routes";
import { IUploadFileResponse } from "../interface/responses/IStorageResponses";

class StorageService {
  constructor() {}

  async uploadFile(data: FormData, onProgress?: (progress: number) => void) {
    const response = await httpClient.postMultipart<IUploadFileResponse[]>(
      API_ROUTES.Storage.upload,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            onProgress?.(percentCompleted);
          }
        }
      }
    );
    return response;
  }
}

export const storageService = new StorageService();
export default StorageService;
